import {createLazyResourceTableUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {SignatureModel} from '../../../models/api/signatureModel';
import {AppAction} from '../../appActions';
import {deleteFromResourceTable, LazyResourceTable} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {SignaturesActionsEnum} from './signaturesActions';

const signaturesUpdatedReducer = createLazyResourceTableUpdatedReducer(
  'signatures',
  (signature) => signature.id,
);

export function signaturesReducer(
  state: LazyResourceTable<number, SignatureModel>,
  action: AppAction,
): LazyResourceTable<number, SignatureModel> {
  switch (action.type) {
    // Single signature update.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return signaturesUpdatedReducer(state, action);

    case SignaturesActionsEnum.SIGNATURE_UPDATED:
      return signaturesUpdatedReducer(state, {
        ...action,
        payload: {
          result: {
            signatures: [action.payload],
          },
        },
      });

    // Single signature deletion.
    case SignaturesActionsEnum.SIGNATURE_DELETED:
      return deleteFromResourceTable(state, action.payload);

    case SignaturesActionsEnum.SIGNATURES_MARK_AS_STALE:
      return {
        ...state,
        isStale: true,
      };

    default:
      return state;
  }
}
